module.exports = __webpack_public_path__ + "src/assets/img/smoke_one.b8f0e80f.svg";